import { PhosphorIcon } from "~/widgets/icons";
import { coinIcon } from "~/assets/assets";
import { useDenominationsGridWebstoreTelescopeContext } from "../context/denominations_grid";
import { HubbleRewardsModal } from "../../hubble_rewards_modal";
import { openModalV2 } from "~/shared_states/modal";

function CoinEarningInformation() {
  const { internalState } = useDenominationsGridWebstoreTelescopeContext();
  const { hubbleCoinRewards } = internalState;
  return (
    <div class="my-4 flex flex-col gap-1">
      <p class="flex items-center gap-1 text-para-3-medium text-text-normal-primary">
        Earning {hubbleCoinRewards()?.percentage}% rewards{" "}
        <PhosphorIcon
          name="info"
          fontSize={15}
          class="cursor-pointer text-baseSecondaryLight"
          size="bold"
          onClick={() => {
            openModalV2(() => <HubbleRewardsModal />, {
              size: "medium",
            });
          }}
        />
      </p>
      <div class="flex items-center gap-1">
        <img src={coinIcon} class="h-[25px] w-[25px]" />{" "}
        <p class="text-title-3-semi-bold text-[var(--color-yellow-600)]">
          {hubbleCoinRewards()?.amount! % 1 === 0
            ? hubbleCoinRewards()?.amount
            : hubbleCoinRewards()?.amount.toFixed(2)}
        </p>
      </div>
    </div>
  );
}

export default CoinEarningInformation;
